export type MobileVideoPageInput = {
  people: number;
  currentPage: number;
  pageCount: number;
  maxStreams: number;
};

export type MobileVideoPageView = {
  peopleLabel: string;
  showPager: boolean;
  pageLabel: string | null;
  canPrev: boolean;
  canNext: boolean;
  nextLabel: string;
};

/** Limite de câmeras da página. No celular estreito vale o teto mobile do preset. */
export function mobileStreamLimit(
  viewportWidth: number,
  max: { mobile?: number; desktop?: number } | null | undefined,
): number {
  const raw = viewportWidth >= 768 ? max?.desktop : max?.mobile;
  if (typeof raw !== "number" || !Number.isFinite(raw) || raw <= 0) {
    return Number.POSITIVE_INFINITY;
  }
  return raw;
}

/**
 * A grade do celular mostra uma tela. A seta nativa só existe no cabeçalho,
 * que no telefone fica escondido. Aqui a segunda tela aparece quando há
 * mais gente do que cabe, ou quando a paginação já está aberta.
 */
export function buildMobileVideoPageView(input: MobileVideoPageInput): MobileVideoPageView {
  const people = Math.max(0, Math.round(input.people));
  const pageCount = Math.max(0, Math.round(input.pageCount));
  const currentPage = Math.max(0, Math.round(input.currentPage));
  const capped = Number.isFinite(input.maxStreams) && input.maxStreams > 0;
  const overflow = capped && people >= input.maxStreams && people > 1;
  const showPager = pageCount > 1 || (pageCount === 0 && overflow);
  const canPrev = pageCount > 1 && currentPage > 1;
  const canNext = (pageCount > 1 && currentPage < pageCount) || (pageCount === 0 && overflow);

  return {
    peopleLabel: people === 1 ? "1 pessoa" : `${people} pessoas`,
    showPager,
    pageLabel: pageCount > 1 ? `${Math.max(currentPage, 1)}/${pageCount}` : null,
    canPrev,
    canNext,
    nextLabel: pageCount > 1 ? "Próxima" : "Próxima tela",
  };
}
